export default "__VITE_ASSET__C$cQC81a__"